import { ProductTypes } from '~src/model';

import { SELECTED_PRODUCT_TYPES } from './useCachedState';
import { useSessionStorage } from './useStorage';

export const useSelectedProductTypes = (
  allowedProductTypes: ProductTypes = ['heatPump', 'solar'],
  initiallySelectedProductTypes: ProductTypes = ['solar']
) => {
  const [selectedProductTypes, setSelectedProductTypes] = useSessionStorage<ProductTypes>(
    SELECTED_PRODUCT_TYPES,
    initiallySelectedProductTypes
  );

  const updateSelectedProductTypes = (newProductTypes: ProductTypes) => {
    const filteredSelectedProductTypes = newProductTypes.filter(selectedType =>
      allowedProductTypes.includes(selectedType)
    );

    if (!filteredSelectedProductTypes.length) {
      return;
    }

    setSelectedProductTypes(filteredSelectedProductTypes);
  };

  return {
    selectedProductTypes: selectedProductTypes ?? [],
    setSelectedProductTypes: updateSelectedProductTypes,
  };
};
